import * as tslib_1 from "tslib";
import React from 'react';
import styled from 'styled-components';
import { Body2 } from 'sinoui-components/Text';
import dayjs from 'dayjs';
import CalendarDayGridLayout from './CalendarDayGridLayout';
import CalendarDayItem from './CalendarDayItem';
var Month = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 75px;\n  height: 40px;\n  position: absolute;\n  padding-left: 14px;\n  padding-top: 12px;\n  float: left;\n"], ["\n  width: 75px;\n  height: 40px;\n  position: absolute;\n  padding-left: 14px;\n  padding-top: 12px;\n  float: left;\n"])));
// export interface State {
//   dayNum: number;
// }
var CalendarDayGrid = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarDayGrid, _super);
    // tslint:disable-next-line:no-any
    function CalendarDayGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.getDayDate = _this.getDayDate.bind(_this);
        _this.getMonthData = _this.getMonthData.bind(_this);
        _this.isToday = _this.isToday.bind(_this);
        _this.isEnable = _this.isEnable.bind(_this);
        _this.isChecked = _this.isChecked.bind(_this);
        return _this;
    }
    /**
     * 获取每个月的天数数据
     *
     * @param {number} yearMonth
     * @returns
     */
    CalendarDayGrid.prototype.getDayDate = function (yearMonth) {
        var today = dayjs();
        var day = today.format('YYYY-MM-DD');
        var dayNow = today.date();
        var monthNow = today.month() + 1;
        var yearNow = today.year();
        var year = today.year();
        var month = this.props.monthChecked;
        var firstday = dayjs(yearMonth + '-01');
        var monthDay = dayjs(new Date(year, month, 0));
        var weekDay = firstday.day(); // 获取周几
        var monthDayNum = monthDay.date(); // 获取每个月的天数
        var lastWeekDay = new Date(year, month - 1, monthDayNum).getDay(); // 最后一天周几
        var dayArr = [];
        if (weekDay > 0) {
            for (var i = 1; i <= weekDay; i++) {
                dayArr.push(React.createElement(CalendarDayItem, null));
            }
        }
        for (var i = 1; i <= monthDayNum; i++) {
            dayArr.push(React.createElement(CalendarDayItem, { dayNum: i, selectDay: this.props.selectDay, checked: this.isChecked(i), enable: this.isEnable(i), today: this.isToday(i) }));
        }
        return { dayArr: dayArr, month: month, weekDay: weekDay };
    };
    CalendarDayGrid.prototype.isToday = function (dayNum) {
        var today = dayjs();
        var day = today.format('YYYY-MM-DD');
        var dayNow = today.date();
        var monthNow = today.month() + 1;
        var yearNow = today.year();
        if (dayNum === dayNow &&
            yearNow === this.props.yearChecked &&
            monthNow === this.props.monthChecked) {
            return true;
        }
        else {
            return false;
        }
    };
    CalendarDayGrid.prototype.isEnable = function (dayNum) {
        var today = dayjs();
        var monthNow = today.month() + 1;
        var yearNow = today.year();
        if (dayNum === this.props.dayNum &&
            monthNow === this.props.monthChecked &&
            !this.props.isLastChecked) {
            return true;
        }
        else {
            return false;
        }
    };
    CalendarDayGrid.prototype.isChecked = function (dayNum) {
        if (dayNum === this.props.dayNum &&
            this.props.isLastChecked &&
            this.props.monthChecked === this.props.monthLastChecked) {
            return true;
        }
        else {
            return false;
        }
    };
    CalendarDayGrid.prototype.getMonthData = function (month) {
        var monthCh;
        switch (month) {
            case 1:
                monthCh = '一月';
                break;
            case 2:
                monthCh = '二月';
                break;
            case 3:
                monthCh = '三月';
                break;
            case 4:
                monthCh = '四月';
                break;
            case 5:
                monthCh = '五月';
                break;
            case 6:
                monthCh = '六月';
                break;
            case 7:
                monthCh = '七月';
                break;
            case 8:
                monthCh = '八月';
                break;
            case 9:
                monthCh = '九月';
                break;
            case 10:
                monthCh = '十月';
                break;
            case 11:
                monthCh = '十一月';
                break;
            default:
                monthCh = '十二月';
        }
        return monthCh;
    };
    CalendarDayGrid.prototype.render = function () {
        var yearMonth = this.props.yearChecked + '-' + this.props.monthChecked;
        var dayObj = this.getDayDate(yearMonth);
        var monthCh = this.getMonthData(this.props.monthChecked);
        var dayArr = dayObj.dayArr;
        var weekDay = dayObj.weekDay;
        return (React.createElement(React.Fragment, null,
            React.createElement(Month, null,
                React.createElement(Body2, null, monthCh)),
            weekDay <= 1 ? React.createElement("br", null) : null,
            React.createElement(CalendarDayGridLayout, { weekDay: weekDay }, dayArr.map(function (day) { return day; }))));
    };
    return CalendarDayGrid;
}(React.Component));
export default CalendarDayGrid;
var templateObject_1;
//# sourceMappingURL=CalendarDayGrid.js.map